(function () {
  const ACCESS = new Set([
    'SIGN_IN_REQUIRED',
    'MEMBERSHIP_REQUIRED',
    'MEMBERSHIP_SYNC_PENDING',
    'ENTITLED',
    'ENTITLEMENT_UNAVAILABLE',
  ]);

  function setState(root, access, options) {
    const shell = root.querySelector('[data-member-lab-state]');
    const title = root.querySelector('[data-member-lab-state-title]');
    const copy = root.querySelector('[data-member-lab-state-copy]');
    const action = root.querySelector('[data-member-lab-state-action]');
    if (!shell || !title || !copy || !action) return;

    shell.dataset.memberLabState = access;
    title.textContent = options.title;
    copy.textContent = options.copy;
    if (options.actionLabel && options.actionUrl) {
      action.textContent = options.actionLabel;
      action.href = options.actionUrl;
      action.hidden = false;
    } else {
      action.removeAttribute('href');
      action.hidden = true;
    }
  }

  function loadDesigner(root) {
    const shell = root.querySelector('[data-member-lab-state]');
    const designer = root.querySelector('[data-member-lab-designer]');
    const source = root.dataset.designerSrc || '';
    if (!designer || !source) return;

    if (shell) shell.hidden = true;
    designer.hidden = false;
    root.dataset.memberLabResolved = 'ENTITLED';

    if (document.querySelector('script[data-member-lab-designer-runtime]')) return;
    const script = document.createElement('script');
    script.src = source;
    script.defer = true;
    script.dataset.memberLabDesignerRuntime = '';
    document.head.appendChild(script);
  }

  function showDeniedState(root, result) {
    const contactUrl = root.dataset.contactUrl || '/pages/kontakt';
    if (result.access === 'MEMBERSHIP_REQUIRED') {
      const target = typeof result.purchaseTarget === 'string' ? result.purchaseTarget : '';
      setState(root, result.access, {
        title: 'Bobbel Designer — Mitglieder-Vorschau',
        copy: 'Die Wollgötter verlangen derzeit eine aktive FunnyHooks Membership.',
        actionLabel: target ? 'Membership aktivieren' : '',
        actionUrl: target,
      });
      return;
    }
    if (result.access === 'MEMBERSHIP_SYNC_PENDING') {
      setState(root, result.access, {
        title: 'Fast fertig gewickelt',
        copy: 'Deine Membership wurde erkannt. Der Zugang zum Member Lab wird noch synchronisiert. Bitte versuche es später erneut oder kontaktiere uns.',
        actionLabel: 'Kontakt aufnehmen',
        actionUrl: contactUrl,
      });
      return;
    }
    setState(root, 'ENTITLEMENT_UNAVAILABLE', {
      title: 'Das Member Lab macht gerade eine Wickelpause',
      copy: 'Dein Zugang konnte gerade nicht sicher geprüft werden. Bitte versuche es später erneut oder kontaktiere uns.',
      actionLabel: 'Kontakt aufnehmen',
      actionUrl: contactUrl,
    });
  }

  async function initialize(root) {
    if (root.dataset.authenticated !== 'true') return;
    const proxyBase = root.dataset.proxyBase || '/apps/fh-bobbel';
    try {
      const response = await fetch(`${proxyBase}/member-lab/entitlement`, {
        method: 'GET',
        headers: { accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('entitlement_unavailable');
      const result = await response.json();
      if (!result || typeof result !== 'object' || !ACCESS.has(result.access)) {
        throw new Error('invalid_entitlement_response');
      }
      if (result.access === 'ENTITLED') {
        loadDesigner(root);
        return;
      }
      showDeniedState(root, result);
    } catch {
      showDeniedState(root, { access: 'ENTITLEMENT_UNAVAILABLE' });
    }
  }

  document.querySelectorAll('[data-member-lab-gate]').forEach(initialize);
})();
